/**
 * Central API configuration.
 * ---------------------------------------------------------------
 * Every component/service in the app should import BASE_URL / API_ENDPOINTS
 * from this single file instead of hard-coding the hosting API URL anywhere
 * else. If the backend URL ever changes, this is the ONLY place to update.
 * ---------------------------------------------------------------
 */

// You can also override this via an env variable at build time:
//   REACT_APP_API_BASE_URL=https://api.hostingservices.co.in npm run build
export const BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'https://api.hostingservices.co.in';

// All backend route paths in one place.
export const API_ENDPOINTS = {
  ADD_USER: '/addUser',
  GET_USER: '/getUser',
  UPDATE_USER: '/updateUser',
  CHANGE_PASSWORD: '/changePassword',
  LOGIN: '/login',
  CREATE_RAZORPAY_ORDER: '/create-razorpay-order',
  UPDATE_PAYMENT_STATUS: '/update-payment-status',
  GET_PAYMENTS: '/getPayments',
};

const apiConfig = { BASE_URL, API_ENDPOINTS };
export default apiConfig;
